import { CSSProperties } from "react";
import { Right } from "react-bootstrap/lib/Media";

export interface Styles {
  text: CSSProperties;
  imgWrap:CSSProperties;
  img:CSSProperties;
  contentWrap:CSSProperties;
  title:CSSProperties;
  info:CSSProperties;
  careerImgWrap:CSSProperties;
  subTitle:CSSProperties;
  card:CSSProperties;
  noProduct:CSSProperties;

}


const styles: Styles = {
  noProduct:{
    fontSize: 18,
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    fontFamily: "var(--primary-font-semibold)",
    backgroundColor: "var(--primary-color)",
    color:"#fff",
    padding:20,
    borderRadius:16
  },
  card:{
    
    maxWidth:1135,
    marginLeft:"auto",
    marginRight:"auto",
    textAlign:"center"
  },
  text: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
  },
  imgWrap:{
    width:180,
    height:180,
    overflow:"hidden",
    marginLeft:"auto",
    marginRight:"auto"
  },
  img:{
    height:"100%",
    width:"100%",
    objectFit:"contain"
  },
  contentWrap:{},
  title:{
    fontFamily: "var(--primary-font-semibold)",
    color: "var(--heading-color)",
    fontSize: 20,
  },
  info:{
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
  },
  careerImgWrap:{
    width:350,
    height:244,
    overflow:"hidden",
    marginLeft:"auto",
    marginRight:"auto"
  },
  subTitle:{
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 12, 
  }
 };

export default styles;
